export default "__VITE_ASSET__5c6b269c__"